// TODO: update with PermissionsUtil to ensure that user has right to preview activity
import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');

import ErrorBox from '../common/ErrorBox';
import DateString from '../common/DateString';
import AccessButton from '../common/AccessButton';
import ActivityIcon from '../activity/ActivityIcon';

const propTypes = {
    channel: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    template: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
};

const defaultProps = {

};

function ActivityListing(props) {
    if (!props.activity) {
        return <li />;
    }

    if (!props.template) {
        return (
            <li>
                <ErrorBox error={{ message: 'Missing template data' }} />
            </li>
        );
    }

    return (
        <li>
            <a name={`#${props.activity.id}`} />
            <div className="listing activity-listing">
                <div className="left-content">
                    <div className="icon-container">
                        <ActivityIcon activity={props.activity} />
                        {(props.activity.meta_data && props.activity.meta_data.distributionRestricted) ? 
                        <i className="activity-icon-overlap fa fa-asterisk" title="distribution restricted"/>
                        : null}
                    </div>
                    <div className="project-info">
                        <div className="project-title">{props.activity.meta_data.title}</div>
                        <div className="activity-type">{props.template.name}</div>
                        <div className="modified-info">
                            <span>Created: <DateString date={props.activity.created_at} /></span>
                        </div>
                        <div className="modified-info">
                            { !props.activity.modified ?
                                <span>Last Updated: <DateString date={props.activity.created_at} /></span>
                                :
                                <span>Last Updated: <DateString date={props.activity.modified} /></span>
                            }
                        </div>
                    </div>
                </div>
                <div className="right-content">
                    <AccessButton
                    iconPath={`${GlobalConfig.StaticUrl}/img/Open.svg`}
                    iconStyle={{width:'24px'}}
                    text="open"
                    href={`/project/${props.channel}/${props.projectId}/activity/${props.activity.id}`}
                    />
                    <AccessButton
                    iconPath={`${GlobalConfig.StaticUrl}/img/Play.svg`}
                    iconStyle={{width:'24px'}}
                    text="preview"
                    href={`/project/${props.channel}/${props.projectId}/activity/${props.activity.id}/preview`}
                    />
                </div>
            </div>
        </li>
    );
}

ActivityListing.propTypes = propTypes;
ActivityListing.defaultProps = defaultProps;

export default ActivityListing;
